'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();

import { useAuth } from '@/hooks/use-auth';
import { BatchTransferProgressToast } from './batch-transfer-progress-toast';

/**
 * Global manager for batch transfer progress toasts.
 * Mounted at the root layout level to persist across page navigation.
 * Listens for batch transfer events and shows progress toast when active.
 */
export function BatchTransferProgressManager() {
  const { user } = useAuth();
  const userId = user?.user?.id ?? null;

  // Always render the toast component - it will manage its own visibility
  return <BatchTransferProgressToast userId={userId} />;
}
